import { combineReducers } from 'redux'
import productsRed from './products'
import initRed from './init'
import filtersRed from './filters'

export default combineReducers({
  productsRed,initRed,filtersRed
})